export const LIST_ORG_REQUEST = 'LIST_ORG_REQUEST';
export const LIST_ORG_SUCCESS = 'LIST_ORG_SUCCESS';
export const LIST_ORG_FAIL = 'LIST_ORG_FAIL';
export const LIST_ORG_RESET = 'LIST_ORG_RESET';

export const GET_ORG_STATUS_REQUEST = 'GET_ORG_STATUS_REQUEST';
export const GET_ORG_STATUS_SUCCESS = 'GET_ORG_STATUS_SUCCESS';
export const GET_ORG_STATUS_FAIL = 'GET_ORG_STATUS_FAIL';
export const GET_ORG_STATUS_RESET = 'GET_ORG_STATUS_RESET';

export const ADD_ORG_REQUEST = 'ADD_ORG_REQUEST';
export const ADD_ORG_SUCCESS = 'ADD_ORG_SUCCESS';
export const ADD_ORG_FAIL = 'ADD_ORG_FAIL';
export const ADD_ORG_RESET = 'ADD_ORG_RESET';

export const SELECT_ORG_REQUEST = 'SELECT_ORG_REQUEST';
export const SELECT_ORG_SUCCESS = 'SELECT_ORG_SUCCESS';
export const SELECT_ORG_FAIL = 'SELECT_ORG_FAIL';
export const SELECT_ORG_RESET = 'SELECT_ORG_RESET';

export const UPDATE_ORG_REQUEST = 'UPDATE_ORG_REQUEST';
export const UPDATE_ORG_SUCCESS = 'UPDATE_ORG_SUCCESS';
export const UPDATE_ORG_FAIL = 'UPDATE_ORG_FAIL';
export const UPDATE_ORG_RESET = 'UPDATE_ORG_RESET';

export const DELETE_ORG_REQUEST = 'DELETE_ORG_REQUEST';
export const DELETE_ORG_SUCCESS = 'DELETE_ORG_SUCCESS';
export const DELETE_ORG_FAIL = 'DELETE_ORG_FAIL';
export const DELETE_ORG_RESET = 'DELETE_ORG_RESET';

export const DOCTOR_SPECIALITY_REQUEST = 'DOCTOR_SPECIALITY_REQUEST';
export const DOCTOR_SPECIALITY_SUCCESS = 'DOCTOR_SPECIALITY_SUCCESS';
export const DOCTOR_SPECIALITY_FAIL = 'DOCTOR_SPECIALITY_FAIL';
export const DOCTOR_SPECIALITY_RESET = 'DOCTOR_SPECIALITY_RESET';

export const GET_TIME_REQUEST = 'GET_TIME_REQUEST';
export const GET_TIME_SUCCESS = 'GET_TIME_SUCCESS';
export const GET_TIME_FAIL = 'GET_TIME_FAIL';
export const GET_TIME_RESET = 'GET_TIME_RESET';
